/**
 * 브라우저에서 **우리 API를 호출하는 fetch**. Next와 SPA가 같은 컴포넌트를 공유하므로
 * 인증 방식 차이를 여기서 갈라 준다.
 *
 *   Next → 쿠키 세션. 맨 `fetch`면 된다(기본 구현).
 *   SPA  → `Authorization: Bearer` 토큰. **맨 fetch는 401이다.**
 *
 * SPA는 시작할 때 `registerApiFetch`로 토큰을 붙이는 구현을 등록한다
 * (web/src/api/client.ts). `registerUploadHost`·`registerStorageBackend`·
 * `registerLlmJsonBackend`와 같은 방식이다 — 공유 코드는 환경을 모르고, 환경이 자기
 * 구현을 끼운다.
 *
 * 왜 생겼나(2026-09-30): 사진·영수증·GPX 업로드 컴포넌트가 맨 `fetch('/api/…')`를
 * 써서 **SPA에서 한 번도 성공한 적이 없었다** — 요청에 Authorization이 안 실려
 * 전부 "로그인이 필요합니다"(401)였다. 일정 추천과 엑셀 가져오기는 그 문제를 겪고
 * 각자 전송 함수를 주입받도록 고쳐 놨지만(그 주석에 "맨 fetch로는 401"이라고 적혀
 * 있다) 세 곳이 남아 있었다. 운영에서 9/26 이후 올라온 사진·GPX가 0건이었다.
 *
 * **우리 API를 브라우저에서 부르는 새 코드는 맨 `fetch` 대신 `apiFetch`를 쓴다.**
 * 외부 API(Nominatim 등)나 서버 전용 코드는 해당 없다.
 */
type ApiFetch = (path: string, init?: RequestInit) => Promise<Response>;

let impl: ApiFetch = (path, init) => fetch(path, init);

/** SPA가 시작할 때 한 번 부른다. 토큰을 붙이는 구현을 끼운다. */
export function registerApiFetch(fn: ApiFetch): void {
  impl = fn;
}

export const apiFetch: ApiFetch = (path, init) => impl(path, init);
